import React, { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { catchyTextFieldSx } from '../../theme/formStyles';

export interface EntityOption {
  _id: string;
  label: string;
  sublabel?: string;
  meta?: Record<string, string>;
}

interface SearchableEntitySelectProps {
  label: string;
  placeholder?: string;
  value: string;
  options: EntityOption[];
  onChange: (id: string) => void;
  required?: boolean;
}

export const SearchableEntitySelect: React.FC<SearchableEntitySelectProps> = ({
  label, placeholder, value, options, onChange, required,
}) => {
  const selected = useMemo(
    () => options.find((o) => o._id === value) || null,
    [options, value]
  );

  return (
    <Autocomplete
      options={options}
      value={selected}
      onChange={(_e, option) => onChange(option?._id || '')}
      getOptionLabel={(opt) => opt.label}
      isOptionEqualToValue={(opt, val) => opt._id === val._id}
      filterOptions={(opts, { inputValue }) => {
        const q = inputValue.trim().toLowerCase();
        if (!q) return opts;
        return opts.filter((opt) =>
          [opt.label, opt.sublabel].filter(Boolean).some((text) => String(text).toLowerCase().includes(q))
        );
      }}
      renderOption={(props, option) => (
        <li {...props} key={option._id}>
          <div>
            <strong>{option.label}</strong>
            {option.sublabel && (
              <span style={{ display: 'block', fontSize: 13, opacity: 0.75 }}>{option.sublabel}</span>
            )}
          </div>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder || 'Search...'}
          required={required}
          size="small"
          InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
          sx={catchyTextFieldSx}
        />
      )}
      noOptionsText="No records found"
      clearOnEscape
    />
  );
};
